import { render, staticRenderFns } from "./Asset-History.vue?vue&type=template&id=6a62b6f8&"
import script from "./Asset-History.vue?vue&type=script&lang=ts&"
export * from "./Asset-History.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports